import {useListView} from '../core/ListViewProvider'
import {ThemeListToolbar} from './ThemeListToolbar'
import {ThemeListGrouping} from './ThemeListGrouping'
import {ThemeListSearchComponent} from './ThemeListSearchComponent'

const ThemeListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ThemeListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ThemeListGrouping /> : <ThemeListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ThemeListHeader}
